import { defaultBooleanValue } from '@/_schemas/generic';
import { defaultNumericIdOption } from '@/_shared';
import type { RouteListItem } from '@/types';

import type { InventoryKitFormSchema } from './schemas/inventory-kit';
import type { InventoryKitItemFormSchema } from './schemas/inventory-kit-item';

export const defaultValues: Readonly<InventoryKitFormSchema> = {
  id: -1,
  name: '',
  sku: '',
  inventory_kit_items: [],
  category: {
    ...defaultNumericIdOption(),
    track_stock_quantities: defaultBooleanValue(),
    track_serial_numbers: defaultBooleanValue(),
  },
  logo: null,
} as const;

// should be considered as part of inventory instead of settings
export const breadcrumbsLinks: RouteListItem[] = [
  // settingsBcLink,
  { path: '/inventory', name: 'Inventory Kits' },
];

export const inventoryKitItemDefaultValues: Readonly<InventoryKitItemFormSchema> = {
  id: -1,
  inventory_kit_id: -1,
  inventory_id: -1,
  quantity: 1,
  inventory: null,
  sort_order: 0,
} as const;
